<template>
  <div>
    <div class="black_panel_cla">
      <div class="header-button-bar">
        <zk-tool-bar @addTemplate="addTemplate"
                     ref="addAnnouncementReset"></zk-tool-bar>
      </div>
      <zk-table :columns="tempCols"
                :data="tableData"></zk-table>
      <div class="pagination-margin-top">
        <el-pagination background
                       @size-change="pageSizeChange(arguments[0], loadTemplateList)"
                       @current-change="curPageChange(arguments[0], loadTemplateList)"
                       :current-page="pager.curPage"
                       :page-size="pager.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pager.total"></el-pagination>
      </div>
    </div>

    <templateDailog :title="title"
                    :dialogVisible="dialogVisible"
                    :row="row"
                    @close="close"
                    @submit="submit"
                    :enable="enable"></templateDailog>
  </div>
</template>

<script>
import * as tempApi from '@/services/sysOptionsApi.js'
import templateDailog from './template/templateDailog'
import { dateFormat, dateByTimestamp } from '@/utils/utils.js'
export default {
  data () {
    let columns = [
      {
        prop: 'type',
        label: this.$t('sysTemplate.type')
      },
      {
        prop: 'subject',
        label: this.$t('sysTemplate.title')
      },
      {
        prop: 'name',
        label: this.$t('sysTemplate.templateName')
      },
      {
        prop: 'content',
        label: this.$t('sysTemplate.content'),
        minWidth: '200px',
        render (h, params) {
          let test = ''
          let str =
            params.row.content === undefined || params.row.content === ''
          if (!str) {
            test = params.row.content
              .replace(/<\p>/g, '\n')
              .replace(/<\/?.+?>/g, '')
          }
          return h('div', {
            domProps: {
              innerHTML: str ? 'N/A' : test
            }
          })
        }
      },

      {
        prop: 'grouped',
        label: this.$t('sysTemplate.group')
      },
      {
        prop: 'language',
        label: this.$t('sysTemplate.languange'),
        render: (h, params) => {
          return h('zk-dictionary-transform', {
            props: {
              value: params.row.language,
              type: 'language'
            }
          })
        }
      },
      {
        prop: 'status',
        label: this.$t('sysTemplate.satatus'),
        render: (h, params) => {
          return h('zk-dictionary-transform', {
            props: {
              value: params.row.status === true ? 1 : 0,
              type: 'status'
            }
          })
        }
      },
      {
        prop: 'createdBy',
        label: this.$t('sysTemplate.create')
      },
      {
        prop: 'createdDate',
        label: this.$t('sysTemplate.createData'),
        render: (h, params) => {
          return h(
            'span',
            dateFormat(dateByTimestamp(params.row.createdDate * 1000), null)
          )
        }
      },
      {
        prop: 'modifiedBy',
        label: this.$t('sysTemplate.update')
      },
      {
        prop: 'modifiedDate',
        label: this.$t('sysTemplate.updateData'),
        render: (h, params) => {
          return h(
            'span',
            dateFormat(dateByTimestamp(params.row.modifiedDate * 1000), null)
          )
        }
      },

      {
        label: this.$t('common.operation'),
        minWidth: '200px',
        render: (h, params) => {
          let _self = this
          return h('zk-operate-bar', {
            props: {
              isTextBtn: true
            },
            on: {
              detailTemplate () {
                _self.row = params.row
                _self.detailTemplate()
              },
              editTemplate () {
                _self.row = params.row
                _self.editTemplate()
              },
              deleteTemplate () {
                _self.row = params.row
                _self.deleteTemplate()
              }
            }
          })
        }
      }
    ]
    return {
      tableData: [],
      tempCols: columns,
      row: {},
      title: '',
      dialogVisible: false,
      enable: false,
      status: 0 // 1新增  2 编辑  3 预览
    }
  },
  components: {
    templateDailog
  },
  mounted () {
    this.loadTemplateList()
  },
  methods: {
    submit (params) {
      if (this.status === 1) {
        tempApi
          .templateAdd(params)
          .then((data) => {
            if (data.code === '00000000') {
              this.dialogVisible = false
              this.loadTemplateList()
              this.$message.success(this.$t('operationMsg.addSuc'))
            } else {
              this.$message.error(data.message)
            }
          })
          .catch((e) => { })
      } else if (this.status === 2) {
        tempApi
          .templateUpdate(params)
          .then((data) => {
            if (data.code === '00000000') {
              this.dialogVisible = false
              this.loadTemplateList()
              this.$message.success(this.$t('operationMsg.updateSuc'))
            } else {
              this.$message.error(data.message)
            }
          })
          .catch((e) => { })
      } else if (this.status === 3) {
        this.dialogVisible = false
      }
    },
    close () {
      this.dialogVisible = false
      this.row = {}
    },
    deleteTemplate () {
      this.$confirm(
        this.$t('sysTemplate.delteTemplate'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.yes'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            id: this.row.id
          }
          tempApi
            .templateDelete(params)
            .then((data) => {
              if (data.code === '00000000') {
                this.$message.success(this.$t('operationMsg.deleteSuc'))
                this.loadTemplateList()
              } else {
                this.$message.error(data.message)
              }
            })
            .catch((e) => { })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    editTemplate () {
      this.dialogVisible = true
      this.title = this.$t('sysTemplate.editTemp')
      this.enable = false
      this.status = 2
    },
    detailTemplate () {
      this.dialogVisible = true
      this.title = this.$t('sysTemplate.viewTemp')
      this.enable = true
    },
    addTemplate () {
      this.dialogVisible = true
      this.title = this.$t('sysTemplate.addTemp')
      this.enable = false
      this.status = 1
    },
    query () {
      this.pager = {
        curPage: 1,
        pageSize: 10
      }
      this.loadTemplateList()
    },
    loadTemplateList () {
      let params = {
        pager: this.pager,
        params: {}
      }
      tempApi.list(params).then((data) => {
        if (data.code === '00000000') {
          this.tableData = data.payload.results
          this.pager.curPage = data.payload.curPage
          this.pager.pageSize = data.payload.pageSize
          this.pager.total = data.payload.totalRecords
        } else {
          this.$message.error(data.message)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/sysOptions/sysTemplate.vue